import { Component, OnInit } from '@angular/core';
import { NgxRolesService } from 'ngx-permissions';
import * as QRCode from 'qrcode';

interface AppInfo {
  name: string;
  description: string;
  version: string;
  category: 'Parent' | 'Administrateur';
  googlePlayUrl?: string;
  appleStoreUrl?: string;
  googlePlayQr?: string;
  appleStoreQr?: string;
  hideForEssentiel?: boolean;
  hideForStart?: boolean;
}

@Component({
  selector: 'app-app-links',
  templateUrl: './app-links.component.html',
  styleUrls: ['./app-links.component.css']
})
export class AppLinksComponent implements OnInit {

  isEssentiel = false;
  isPackStart = false;
  apps: AppInfo[] = [];
  displayApps: AppInfo[] = [];

  constructor(private roleService: NgxRolesService) {
    this.isEssentiel = !!this.roleService.getRole('ROLE_PACK_ESSENTIEL');
    this.isPackStart = !!this.roleService.getRole('ROLE_PACK_START');
  }

  ngOnInit() {
    this.apps = [
      {
        name: 'Madarstop',
        description: 'Application mobile pour les parents : suivez les trajets de vos enfants en temps réel et recevez les notifications de départ et d\'arrivée.',
        version: '2.1.1',
        category: 'Parent',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.inovsys.madar_stop&pcampaignid=web_share',
        appleStoreUrl: 'https://apps.apple.com/ma/app/madarstop/id1642115740',
        hideForStart: true
      },
      {
        name: 'Madarstop Driver',
        description: 'Application mobile pour les chauffeurs : gérez vos tournées, enregistrez les arrêts des parents et assurez le bon déroulement des trajets.',
        version: '1.0.7',
        category: 'Administrateur',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.inovsys.MadarStopDriver&pcampaignid=web_share',
        hideForEssentiel: true,
        hideForStart: true
      },
      {
        name: 'Madar Pro',
        description: 'Application de supervision : suivez la position de vos véhicules en temps réel et gérez l\'ensemble de votre flotte.',
        version: '2.0.6',
        category: 'Administrateur',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.inovsys.madar_geo_mobile&pcampaignid=web_share',
        appleStoreUrl: 'https://apps.apple.com/ma/app/madar-pro/id1633052274'
      }
    ];

    this.displayApps = this.apps.filter(app => !(this.isEssentiel && app.hideForEssentiel) && !(this.isPackStart && app.hideForStart));

    this.generateQrCodes();
  }

  async generateQrCodes() {
    for (const app of this.displayApps) {
      if (app.googlePlayUrl) {
        app.googlePlayQr = await QRCode.toDataURL(app.googlePlayUrl, {
          width: 180,
          margin: 1,
          color: { dark: '#000000', light: '#FFFFFF' }
        });
      }
      if (app.appleStoreUrl) {
        app.appleStoreQr = await QRCode.toDataURL(app.appleStoreUrl, {
          width: 180,
          margin: 1,
          color: { dark: '#000000', light: '#FFFFFF' }
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-links/app-links.component.ts